import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportsService } from '../services/reports.service';
import { first } from 'rxjs/operators';
import { Division } from '../model/division.model';
import ArrayStore from 'devextreme/data/array_store';
import { ImageModel } from '../model/image.model';
import { Incident } from '../model/incident.model';
import { ReportImageService } from '../services/report-image.service';
import { NotificationService } from '../services/notification.service';
import { DxScrollViewComponent, DxValidationGroupComponent } from 'devextreme-angular';
import { _ } from '@biesbjerg/ngx-translate-extract/dist/utils/utils';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../constants/constants';
import { IncidentsService } from '../services/incidents.service';
import { IncidentHelper } from '../model/incident-helper.model';
import { ReferencesService } from '../services/references.service';
import { ReferenceHelper } from '../model/reference-helper.model';
import { HeaderType } from '../model/header-type.enum';
import { Address } from '../model/address.model';
import { HelperService } from '../services/helper.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

  constructor(private reportsService: ReportsService,
              private incidentService: IncidentsService,
              private referencesService: ReferencesService,
              private reportImageService: ReportImageService,
              private notificationService: NotificationService,
              private translateService: TranslateService,
              private helperService: HelperService) {
  }

  @ViewChild('validationGroupReporterName', { static: false })
  validationGroupReporterName: DxValidationGroupComponent;

  @ViewChild('validationGroupReporterSurname', { static: false })
  validationGroupReporterSurname: DxValidationGroupComponent;

  @ViewChild('scrollView', { static: false })
  scrollView: DxScrollViewComponent;

  incidentManagementEnabled = false;
  title;
  isVisible = false;
  report: Incident = {
    ArrivalTime: '',
    CivilEngineerArrival: '',
    CivilEngineerInformed: '',
    CivilEngineerName: '',
    Classification: '',
    CreatedDate: '',
    DamageCode: '',
    DamageCodeDescription: '',
    DamageReasonCode: '',
    DamageReasonCodeDescription: '',
    DepartureTime: '',
    Division: '',
    ESTMID: '',
    Forwarded: '',
    HasGasDetected: true,
    HasReferences: false,
    IncidentCity: '',
    IncidentCityPart: '',
    IncidentHouseNo: '',
    IncidentKey: '',
    IncidentName: '',
    IncidentPhone: '',
    IncidentPostalCode: '',
    IncidentRemarks: '',
    IncidentState: '',
    IncidentStreet: '',
    IncidentSurname: '',
    InitialSafeguardingMeasures: false,
    IsEmergency: false,
    Location: '',
    ProcessOwner: '',
    ProcessStarted: '',
    ReferencedRecords: [],
    ReporterCity: '',
    ReporterCityPart: '',
    ReporterHouseNo: '',
    ReporterName: '',
    ReporterPhone: '',
    ReporterPostalCode: '',
    ReporterRemarks: '',
    ReporterStreet: '',
    ReporterSurname: '',
    ResponseGroup: '',
    STMID: '',
    Source: '',
    Type: 0,
    UserID: '',
    UserName: ''
  };
  divisions: ArrayStore<Division> = new ArrayStore<Division>();
  selectedReportImage: ImageModel;
  reporterPostalCodes: string[];
  reporterCities: string[];
  reporterStreets: string[];
  reporterHouseNos: string[];
  reporterCityParts: string[];
  incidentPostalCodes: string[];
  incidentCities: string[];
  incidentStreets: string[];
  incidentHouseNos: string[];
  incidentCityParts: string[];
  locations: string[];
  sources: string[] = Constants.SOURCES;
  btnIncidentModalText: string;

  private isCreateRequested = false;
  private rowKey: string;
  private addresses: Address[];
  private reportImages: ImageModel[];
  private stmid: string;
  private valueMappingConfiguration: Map<string, string> = new Map([
    ['ReporterName', 'IncidentName'],
    ['ReporterSurname', 'IncidentSurname'],
    ['ReporterPhone', 'IncidentPhone'],
    ['ReporterCity', 'IncidentCity'],
    ['ReporterStreet', 'IncidentStreet'],
    ['ReporterPostalCode', 'IncidentPostalCode'],
    ['ReporterHouseNo', 'IncidentHouseNo'],
    ['ReporterCityPart', 'IncidentCityPart']
  ]);

  ngOnInit(): void {
    this.incidentManagementEnabled = this.helperService.getStartupConfiguration().incidentManagementEnabled;
    this.getDivisions();
    this.getAddresses();
    this.getCreateModeNotification();
    this.getEditModeNotification();
    this.getEditModeBySTMIDNotification();
    this.getReportImages();
    this.getRefreshReportFormNotification();
  }

  getContentHeight(): string {
    return 'calc(80vh - 160px)';
  }

  onReporterPostalCodeChanged(e: any): void {
    setTimeout(() => {
      if (e.value !== null && e.value !== '') {
        const filteredAddresses = this.addresses.filter(x => x.ZIP === e.value);
        this.reporterCities = filteredAddresses.map(c => c.City);
        this.reporterCityParts = filteredAddresses.map(c => c.CityPart);
        this.reporterStreets = filteredAddresses.map(c => c.Street);
      } else {
        this.reporterCities = this.addresses.map(c => c.City);
        this.reporterCityParts = this.addresses.map(c => c.CityPart);
        this.reporterStreets = this.addresses.map(c => c.Street);
      }
    }, 0);
  }

  onReporterCityChanged(e: any): void {
    setTimeout(() => {
      if (e.value !== null && e.value !== '') {
        const filteredAddresses = this.addresses.filter(x => x.City === e.value);
        this.reporterPostalCodes = filteredAddresses.map(c => c.ZIP);
        this.reporterCityParts = filteredAddresses.map(c => c.CityPart);
        this.reporterStreets = filteredAddresses.map(c => c.Street);
      } else {
        this.reporterPostalCodes = this.addresses.map(c => c.ZIP);
        this.reporterCityParts = this.addresses.map(c => c.CityPart);
        this.reporterStreets = this.addresses.map(c => c.Street);
      }
    }, 0);
  }

  onReporterStreetChanged(e: any): void {
    setTimeout(() => {
      if (e.value !== null && e.value !== '') {
        const filteredAddresses = this.addresses.filter(x => x.Street === e.value);
        this.reporterPostalCodes = filteredAddresses.map(c => c.ZIP);
        this.reporterCityParts = filteredAddresses.map(c => c.CityPart);
        this.reporterCities = filteredAddresses.map(c => c.City);
      } else {
        this.reporterPostalCodes = this.addresses.map(c => c.ZIP);
        this.reporterCityParts = this.addresses.map(c => c.CityPart);
        this.reporterCities = this.addresses.map(c => c.City);
      }
    }, 0);
  }

  onIncidentPostalCodeChanged(e: any): void {
    setTimeout(() => {
      if (e.value !== null && e.value !== '') {
        const filteredAddresses = this.addresses.filter(x => x.ZIP === e.value);
        this.incidentCities = filteredAddresses.map(c => c.City);
        this.incidentCityParts = filteredAddresses.map(c => c.CityPart);
        this.incidentStreets = filteredAddresses.map(c => c.Street);
      } else {
        this.incidentCities = this.addresses.map(c => c.City);
        this.incidentCityParts = this.addresses.map(c => c.CityPart);
        this.incidentStreets = this.addresses.map(c => c.Street);
      }
    }, 0);
  }

  onIncidentCityChanged(e: any): void {
    setTimeout(() => {
      if (e.value !== null && e.value !== '') {
        const filteredAddresses = this.addresses.filter(x => x.City === e.value);
        this.incidentPostalCodes = filteredAddresses.map(c => c.ZIP);
        this.incidentCityParts = filteredAddresses.map(c => c.CityPart);
        this.incidentStreets = filteredAddresses.map(c => c.Street);
      } else {
        this.incidentPostalCodes = this.addresses.map(c => c.ZIP);
        this.incidentCityParts = this.addresses.map(c => c.CityPart);
        this.incidentStreets = this.addresses.map(c => c.Street);
      }
    }, 0);
  }

  onIncidentStreetChanged(e: any): void {
    setTimeout(() => {
      if (e.value !== null && e.value !== '') {
        const filteredAddresses = this.addresses.filter(x => x.Street === e.value);
        this.incidentPostalCodes = filteredAddresses.map(c => c.ZIP);
        this.incidentCityParts = filteredAddresses.map(c => c.CityPart);
        this.incidentCities = filteredAddresses.map(c => c.City);
      } else {
        this.incidentPostalCodes = this.addresses.map(c => c.ZIP);
        this.incidentCityParts = this.addresses.map(c => c.CityPart);
        this.incidentCities = this.addresses.map(c => c.City);
      }
    }, 0);
  }

  submitReport(e: any): void {
    const validReporterName = this.validationGroupReporterName.instance.validate();
    const validReporterSurname = this.validationGroupReporterSurname.instance.validate();
    if (validReporterName.isValid && validReporterSurname.isValid) {
      let success = null;
      this.reportsService.saveReport(this.report).pipe(first()).subscribe(result => {
        success = result !== undefined;
        if (success) {
          this.notificationService.showSuccessMessage(this.translateService.instant(_('Report successfully saved!')));
          this.popupHiding();
          this.reportsService.refreshGridNotify();
        }
      });
    }
    e.preventDefault();
  }

  popupHiding(): void {
    this.isVisible = false;
    this.scrollView.instance.scrollTo(0);
  }

  openIncidentModal(e: any): void {
    this.submitReport(e);
    if (this.report.HasReferences) {
      const incidentHelper: IncidentHelper = { RowKey: this.report.ReferencedRecords[0], STMID: this.report.STMID };
      this.incidentService.editIncidentFromReportNotify(incidentHelper);
    } else {
      this.incidentService.createIncidentFromReportNotify(this.report);
    }
  }

  cancelRequest(): void {
    if (!this.isVisible) {
      return;
    }
    if (this.isCreateRequested) {
      this.reportsService.cancelReport(this.report.STMID).pipe(first()).subscribe(resp => {
        if (!resp) {
          this.notificationService.showErrorMessage('Could not delete report on Cancel request.');
        }
      });
    }
    this.popupHiding();
  }

  referenceReport(): void {
    const referenceHelper: ReferenceHelper = {
      ParentRowKey: this.report.IncidentKey,
      HeaderType: HeaderType.REPORTS,
      Division: this.report.Division
    };
    this.referencesService.referenceNotify(referenceHelper);
  }

  setTodayButton(e: any): void {
    e.component._popup.option('toolbarItems[0]', {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'before',
      options: {
        text: 'Today',
        onClick: (x) => {
          e.component.option('value', new Date());
        }
      }
    });
  }

  private createReport(division: number): void {
    this.reportsService.createReport(division).pipe(first()).subscribe(reportData => {
      this.report = this.helperService.getValueCopyingIncidentProxy(reportData, this.valueMappingConfiguration);
      this.selectedReportImage = this.reportImages.find(element => element.Name === this.report.Division);
      this.getLocations(division);
      this.btnIncidentModalText = this.translateService.instant(_('Create Incident'));
    });
  }

  private editReport(): void {
    this.reportsService.editReport(this.rowKey).pipe(first()).subscribe(reportData => {
      this.report = this.helperService.getValueCopyingIncidentProxy(reportData, this.valueMappingConfiguration);
      this.selectedReportImage = this.reportImages.find(element => element.Name === this.report.Division);
      if (this.report.HasReferences) {
        this.btnIncidentModalText = this.translateService.instant(_('Show Incident'));
      } else {
        this.btnIncidentModalText = this.translateService.instant(_('Create Incident'));
      }
      const assignedDivision: number = this.getDivisionID(this.report.Division);
      if (assignedDivision !== null) {
        this.getLocations(assignedDivision);
      }
    });
  }

  private editReportBySTMID(): void {
    this.reportsService.editReportBySTMID(this.stmid).pipe(first()).subscribe(data => {
      this.report = data;
      this.selectedReportImage = this.reportImages.find(element => element.Name === this.report.Division);
      if (this.report.HasReferences) {
        this.btnIncidentModalText = this.translateService.instant(_('Show Incident'));
      } else {
        this.btnIncidentModalText = this.translateService.instant(_('Create Incident'));
      }
      const assignedDivision: number = this.getDivisionID(this.report.Division);
      if (assignedDivision !== null) {
        this.getLocations(assignedDivision);
      }
    });
  }

  private getDivisionID(division: string): number {
    let id = null;
    this.divisions.byKey(division).then(
      (dataItem) => {
        id = Number(dataItem.ID);
      },
      (error) => {
        this.notificationService.showErrorMessage(error);
      }
    );
    return id;
  }

  private getReportImages(): void {
    this.reportImages = this.reportImageService.getReportImagesOfDivisions();
  }

  private getCreateModeNotification(): void {
    this.reportsService.getCreateModeNotification().subscribe(division => {
      this.title = this.translateService.instant(_('Create Report'));
      this.createReport(division);
      this.isCreateRequested = true;
      this.isVisible = true;
    });
  }

  private getEditModeNotification(): void {
    this.reportsService.getEditModeNotification().subscribe(rowKey => {
      this.title = this.translateService.instant(_('Edit Report'));
      this.rowKey = rowKey;
      this.editReport();
      this.isCreateRequested = false;
      this.isVisible = true;
    });
  }

  private getEditModeBySTMIDNotification(): void {
    this.reportsService.getEditModeBySTMIDNotification().subscribe(stmid => {
      this.title = this.translateService.instant(_('Edit Report'));
      this.stmid = stmid;
      this.editReportBySTMID();
      this.isCreateRequested = false;
      this.isVisible = true;
    });
  }

  private getDivisions(): void {
    this.reportsService.getDivisions().pipe(first()).subscribe(divisionsContainer => {
      this.divisions = new ArrayStore({ data: divisionsContainer._Divisions, key: 'Name' });
    });
  }

  private getAddresses(): void {
    this.reportsService.getAddresses().pipe(first()).subscribe(addressesContainer => {
      this.addresses = addressesContainer._Addresses;
      const postalCodes = this.addresses.map((a) => a.ZIP);
      const cities = this.addresses.map((a) => a.City);
      const cityParts = this.addresses.map((a) => a.CityPart);
      const streets = this.addresses.map((a) => a.Street);
      const houseNos = this.addresses.map((a) => a.HouseNo);
      this.reporterPostalCodes = postalCodes;
      this.reporterCities = cities;
      this.reporterCityParts = cityParts;
      this.reporterStreets = streets;
      this.reporterHouseNos = houseNos;
      this.incidentPostalCodes = postalCodes;
      this.incidentCities = cities;
      this.incidentCityParts = cityParts;
      this.incidentStreets = streets;
      this.incidentHouseNos = houseNos;
    });
  }

  private getLocations(division: number): void {
    this.reportsService.getLocations(division).pipe(first()).subscribe(locationsContainer => {
      if (locationsContainer != null) {
        this.locations = locationsContainer.Locations.map((l) => l.Name);
      }
    });
  }

  private getRefreshReportFormNotification(): void {
    this.referencesService.getRefreshReportFormNotification().subscribe(success => {
      this.editReport();
    });
  }
}
